import { ReactElement, useState } from "react";
import { IPanelProps } from "./types";
import TextField from "@mui/material/TextField";
import { Checkbox, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutlineOutlined";

const AdditionalIssuesPanel = ({ value, property, onChange }: IPanelProps<string []>): ReactElement => {
  const [ checked, setChecked ] = useState<number[]>([]);

  const onChecked = (index: number, isChecked: boolean) => {
    if (isChecked) {
      setChecked([...checked, index]);
    } else {
      setChecked(checked.filter(x => x !== index));
    }
  };

  const onChangeComment = (index: number, comment: string) => {
    onChange(property, value.map((str, indexStr) => indexStr === index ? comment : str));
  };


  const onNewClick = () => {
    setChecked([]);
    onChange(property, [ ...value, "" ]);
  };

  const onDeleteClick = () => {
    const newArray: string[] = [];

    value.forEach((comment, index) => {
      if (!checked.includes(index)) {
        newArray.push(comment);
      }
    });

    setChecked([]);
    onChange(property, newArray);
  };

  return (
    <div className="display-flex-column gap-1 p-1">
      <div>
        <Tooltip title="Add">
          <span>
            <IconButton aria-label="add" color="info" onClick={onNewClick} disabled={value.length >= 5}>
              <AddCircleOutlineIcon/>
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="Delete">
          <span>
            <IconButton aria-label="delete" color="error" disabled={checked.length === 0}  onClick={onDeleteClick}>
              <DeleteIcon/>
            </IconButton>
          </span>
        </Tooltip>
      </div>
      {value.map((comment, index) => {

        return (
          <div key={`comment-${index}`} className="display-flex-row gap-1">
            <Checkbox
              checked={checked.includes(index)}
              tabIndex={-1}
              disableRipple={true} onChange={(_event, isChecked) => onChecked(index, isChecked)}/>
            <TextField
              variant="standard"
              multiline={true}
              minRows={4}
              maxRows={4}
              value = {comment}
              fullWidth={true}
              onChange={event => onChangeComment(index, event.target.value)}
            />
          </div>
        );
      })}
    </div>
  );
};

export default AdditionalIssuesPanel;